import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/Logo";

const NAV_LINKS = [
  { label: "Services", href: "/services" },
  { label: "Solutions", href: "/#solutions" },
  { label: "Strategy", href: "/strategy" },
  { label: "For You", href: "/#for-you" },
  { label: "Tools", href: "/tools" },
  { label: "Insights", href: "/insights/scenarios" },
  { label: "Learn", href: "/learn" },
  { label: "Process", href: "/process" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-colors duration-300 ${
        scrolled ? "nav-scrolled" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 sm:h-20">
          <Logo />

          <nav
            className="hidden lg:flex items-center gap-9"
            aria-label="Primary"
          >
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-link-${l.href.replace("#", "")}`}
                className="font-sans-ui text-sm font-medium text-lw-navy/80 hover:text-lw-navy relative transition-colors duration-200 group"
              >
                {l.label}
                <span className="absolute -bottom-1 left-0 right-0 h-px bg-lw-gold scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left" />
              </a>
            ))}
          </nav>

          <div className="hidden lg:block">
            <a
              href="/#contact"
              data-testid="nav-cta-get-started"
              className="btn-gold text-sm"
            >
              Get Started
              <span aria-hidden="true">→</span>
            </a>
          </div>

          <button
            type="button"
            data-testid="nav-mobile-toggle"
            className="lg:hidden inline-flex items-center justify-center p-2 rounded-md text-lw-navy hover:bg-lw-navy/5"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((v) => !v)}
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-panel"
          className="lg:hidden border-t border-lw-navy/10 bg-[#faf8f3]/95 backdrop-blur-md"
        >
          <div className="max-w-7xl mx-auto px-5 py-4 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                className="py-3 px-2 font-sans-ui text-base font-medium text-lw-navy/90 hover:text-lw-navy border-b border-lw-navy/5"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="btn-gold mt-3 justify-center"
            >
              Get Started →
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
